export default __webpack_public_path__ + "static/media/Punto_05_Scali_Rosciano_ITA_Def.f33d6037.aac";